export const timeout = {
    fiveSeconds: 5000

}
